<template>
  <v-container id="change-password">
    <v-row>
      <v-col sm="8" offset-sm="2" md="6" offset-md="3" lg="4" offset-lg="4">
        <v-col class="text-center">
          <h1>Primeiro Acesso</h1>
        </v-col>
        <div>
          Bem vindo, cadastre sua senha abaixo para fazer login ao sistema.
        </div>
        <v-form lazy-validation @submit.prevent="onSubmit">
          <v-text-field
            id="password"
            label="Nova Senha"
            name="password"
            type="password"
            v-model="payload.senha"
            :rules="passwordRules"
            required
            maxLength="8"
          ></v-text-field>

          <v-text-field
            id="confirm-password"
            label="Confirmação de Senha"
            name="confirm-password"
            type="password"
            v-model="payload.confirmacaoSenha"
            :rules="confirmPasswordRules"
            maxLength="8"
            required
          ></v-text-field>
          <div class="mt-5">
            <div
              v-for="(especificacao, index) in especificacaoSenha"
              :key="index"
              :class="
                errosSenha.includes(especificacao.name) ? 'falta' : '' + 'espec'
              "
            >
              -
              {{ especificacao.title }}
            </div>
          </div>
          <v-row>
            <v-col>
              <div class="text-center">
                <v-btn color="primary" type="submit"> Cadastrar Senha </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { userAPI } from "./UserAPI";
import {
  regexSenhaQuebrado,
  especificacaoLabels,
} from "@/helpers/senhaEspecificacao";

export default {
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      payload: {},
      especificacaoSenha: especificacaoLabels,
      errosSenha: [],
      token: this.$route.query.token,
      passwordRules: [
        (v) => !!v || "O campo nova senha é obrigatório",
        (v) => {
          if (v && !this.regexSenhaQuebrado.totalRegex.test(v)) {
            this.errosSenha = [];
            !this.regexSenhaQuebrado.letraMinuscula.test(v) &&
              this.errosSenha.push("minuscula");
            !this.regexSenhaQuebrado.letraMaiuscula.test(v) &&
              this.errosSenha.push("maiuscula");
            !this.regexSenhaQuebrado.numero.test(v) &&
              this.errosSenha.push("numero");
            !this.regexSenhaQuebrado.especial.test(v) &&
              this.errosSenha.push("especial");
            !v.length !== 8 && this.errosSenha.push("caracteres");

            return "Senha fraca";
          }
          this.errosSenha = [];
          return true;
        },
      ],
      regexSenhaQuebrado: regexSenhaQuebrado,
      confirmPasswordRules: [
        (v) => !!v || "O campo confirmação de senha é obrigatório",
        (v) => {
          if (v !== this.payload.senha) {
            return "As senhas devem ser iguais";
          }
          return true;
        },
      ],
      valid: true,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    onSubmit() {
      if (!this.payload.senha || !this.payload.confirmacaoSenha) {
        this.$notification.error(
          "Os campos senha e confirmação de senha são obrigatórios!",
          { timer: 10 }
        );
      } else {
        this.setLoading(true);
        //enviar this.token

        // userAPI
        //   .update(this.payload)
        //   .then((resp) => {
        //     this.$notification.success("Senha atualizada com sucesso!", {
        //       timer: 10,
        //     });
        //     this.$router.push("/cidade");
        //   })
        //   .catch((resp) => {
        //     this.setLoading(false);
        //     this.$notification.error("Erro ao atualizar senha!", { timer: 10 });
        //   });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.falta {
  color: red;
}
</style>
